import { Shield } from "lucide-react";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { appName } from "../utils/env";

export default function LoginPage() {
  useEffect(() => {
    const currentPath =
      window.location.pathname + window.location.search + window.location.hash;
    if (currentPath !== "/" && currentPath !== "/auth/callback") {
      localStorage.setItem("postLoginRedirect", currentPath);
    }

    // Check for stored permission change message
    const loginMessage = localStorage.getItem("loginMessage");
    if (loginMessage) {
      toast.error(loginMessage, {
        duration: 8000,
        position: "top-center",
      });
      localStorage.removeItem("loginMessage");
    }
  }, []);

  const handleAzureLogin = () => {
    window.location.href = "/api/auth/azure/login";
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary-100">
            <Shield className="h-6 w-6 text-primary-600" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {appName()}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Sign in to your account
          </p>
        </div>

        <div className="mt-8 space-y-6">
          {/* Azure AD Login Button */}
          <div>
            <button
              onClick={handleAzureLogin}
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
            >
              Sign in with Microsoft
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
